<section class="page">

  <!-- HERO -->
  <header class="hero">
    <div class="hero__bg">
      <div class="hero__orb hero__orb--primary"></div>
      <div class="hero__orb hero__orb--secondary"></div>
    </div>
    <div class="hero__content">
      <div class="hero__kicker">Platform</div>
      <h1 class="hero__title">{{ 'platform.status.title' | translate }}</h1>
    </div>
  </header>

  <!-- STATUS CONTENT -->
  <div class="status-body">
    @if (announcements$ | async; as list) {
      @if (list.length === 0) {
        <div class="all-ok">
          <mat-icon class="ok-icon">check_circle</mat-icon>
          <p>{{ 'platform.status.all_ok' | translate }}</p>
        </div>
      } @else {
        @for (a of list; track a.id) {
          <div class="status-item" [ngClass]="'severity-' + a.severity">
            <mat-icon>{{ iconFor(a.severity) }}</mat-icon>
            <div class="item-content">
              <strong>{{ a.title }}</strong>
              <p>{{ a.message }}</p>
              <small>{{ 'platform.status.expires' | translate }}: {{ a.expiresAt | date:'medium' }}</small>
            </div>
          </div>
        }
      }
    }
  </div>

</section>
